var _defs, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostsLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#6b6b6b;}.cls-3{fill:#e00000;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.5,
    y: -0.14,
    width: 500,
    height: 500
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m365.81,239.98l-56.32,56.32.04.04-13.17,13.17-.04-.04-56.28,56.33c-3.5,3.5-8.25,5.47-13.2,5.47h-1.31c-5.4-.37-10.37-3.07-13.61-7.4-22.9-30.45-20.7-55.2-15.38-69.97l-62.36-62.56c-7.27-7.29-7.27-19.1.02-26.38l70.77-70.76c3.64-3.65,8.42-5.47,13.2-5.47s9.54,1.82,13.19,5.47l62.5,62.73c12.42-3.9,40.79-8.6,70.43,15.32.53.42,1.03.87,1.5,1.34,7.29,7.28,7.3,19.1.02,26.39Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m359.23,359.21c-3.64,3.65-9.55,3.65-13.2,0l-49.67-49.7,13.17-13.17,49.7,49.67c3.65,3.65,3.65,9.56,0,13.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostsLight);
export default __webpack_public_path__ + "static/media/Posts_Light.9ade26fc44d6e4bfcf8fddf482854529.svg";
export { ForwardRef as ReactComponent };